const renewalHomeRoot = document.querySelector('.maruishi-renewal-home') || document.querySelector('main');
const fabricMenu = renewalHomeRoot?.querySelector('.fabric-menu');
const tabs = fabricMenu ? Array.from(fabricMenu.querySelectorAll('[role="tab"]')) : [];
const panels = fabricMenu ? Array.from(fabricMenu.querySelectorAll('[role="tabpanel"]')) : [];
const fabricTabMobileQuery = window.matchMedia('(max-width: 680px)');

function annotateSectionLinks(section) {
  if (!section?.dataset.sectionName) return;

  Array.from(section.querySelectorAll('a[href]')).forEach((link, index) => {
    const label = link.dataset.itemLabel
      || link.querySelector('h3, strong, .fabric-menu-label')?.textContent.trim()
      || link.textContent.trim();
    link.dataset.sectionName ||= section.dataset.sectionName;
    link.dataset.itemLabel ||= label.slice(0, 100);
    link.dataset.position ||= String(index + 1);
  });
}

function hydratePanel(panel) {
  const template = panel?.querySelector(':scope > template[data-fabric-panel-template]');
  if (!template) return;

  panel.appendChild(template.content.cloneNode(true));
  template.remove();
  panel.dataset.hydrated = 'true';
  annotateSectionLinks(panel.closest('[data-section-name]'));
}

function selectTab(tab) {
  const activePanel = panels.find((panel) => panel.id === tab.getAttribute('aria-controls'));
  hydratePanel(activePanel);

  tabs.forEach((item) => {
    const selected = item === tab;
    item.setAttribute('aria-selected', String(selected));
    item.tabIndex = selected ? 0 : -1;
  });

  panels.forEach((panel) => {
    panel.hidden = panel.id !== tab.getAttribute('aria-controls');
  });
}

tabs.forEach((tab, index) => {
  tab.addEventListener('click', () => selectTab(tab));
  tab.addEventListener('keydown', (event) => {
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;

    event.preventDefault();
    let nextIndex = index;
    if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
    if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
    if (event.key === 'ArrowUp') nextIndex = (index - (fabricTabMobileQuery.matches ? 2 : 1) + tabs.length) % tabs.length;
    if (event.key === 'ArrowDown') nextIndex = (index + (fabricTabMobileQuery.matches ? 2 : 1)) % tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;

    tabs[nextIndex].focus();
    selectTab(tabs[nextIndex]);
  });
});

renewalHomeRoot?.querySelectorAll('section[data-section-name]').forEach(annotateSectionLinks);

const judgeMeHomeSlot = renewalHomeRoot?.querySelector('[data-judge-me-home-slot]');

if (judgeMeHomeSlot) {
  const carouselSelector = '.jdgm-cards-carousel';
  let judgeMeObserver;

  const createElement = (tagName, className, text) => {
    const element = document.createElement(tagName);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };

  const mountJudgeMeCarousel = () => {
    if (judgeMeHomeSlot.dataset.judgeMeReady === 'true') return true;

    const widget = document.querySelector(carouselSelector);
    if (!widget || widget.classList.contains('jdgm-hidden')) return false;

    const reviewCards = widget.querySelectorAll('.jdgm-card, [data-review-id], [data-review-uuid]');
    if (reviewCards.length === 0) return false;

    const appSection = widget.closest('.shopify-section--apps');
    if (!appSection) return false;

    judgeMeObserver?.disconnect();
    appSection.classList.add('review-unified-section');
    const heading = widget.querySelector('.jdgm-title');
    if (heading) heading.textContent = 'お客様の声';

    const moreReviews = createElement('a', 'review-unified-more', 'レビューをもっと見る');
    moreReviews.href = '/pages/reviews';
    moreReviews.dataset.itemLabel = 'レビューをもっと見る';

    judgeMeHomeSlot.replaceChildren(appSection, moreReviews);
    annotateSectionLinks(appSection);
    judgeMeHomeSlot.dataset.judgeMeReady = 'true';
    return true;
  };

  if (!mountJudgeMeCarousel()) {
    judgeMeObserver = new MutationObserver(mountJudgeMeCarousel);
    judgeMeObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    window.setTimeout(() => judgeMeObserver?.disconnect(), 12000);
  }
}

const searchForm = document.querySelector('.maruishi-renewal-header .search-area') || document.querySelector('.search-area');

if (searchForm && searchForm.dataset.renewalBound !== 'true') {
  searchForm.dataset.renewalBound = 'true';
  const searchButtons = Array.from(searchForm.querySelectorAll('[data-search-mode]'));
  const searchInput = searchForm.querySelector('input[type="search"]');
  const searchLabel = searchForm.querySelector('.search-label');
  const searchToggle = searchForm.closest('.maruishi-renewal-header')?.querySelector('.search-toggle') || document.querySelector('.search-toggle');
  const searchToggleLabel = searchToggle?.querySelector('.visually-hidden');
  const queryInput = searchForm.querySelector('input[name="q"]');
  const typeInput = searchForm.querySelector('input[name="type"]');
  const searchModes = {
    product: { label: '商品を検索', placeholder: '商品名や品番を入力', type: 'product', prefix: '' },
    journal: { label: '読みものを検索', placeholder: '記事のキーワードを入力', type: 'article', prefix: 'お読みもの' },
    works: { label: '作品例を検索', placeholder: '作品名や生地名を入力', type: 'article', prefix: '作品例' },
  };

  let activeMode = 'product';

  function selectSearchMode(mode) {
    const config = searchModes[mode];
    if (!config) return;

    activeMode = mode;
    searchButtons.forEach((button) => {
      const selected = button.dataset.searchMode === mode;
      button.classList.toggle('active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    searchInput.placeholder = config.placeholder;
    searchLabel.textContent = config.label;
    typeInput.value = config.type;
  }

  function setMobileSearchOpen(open, moveFocus = true) {
    searchForm.classList.toggle('is-open', open);
    searchToggle?.setAttribute('aria-expanded', String(open));
    if (searchToggleLabel) searchToggleLabel.textContent = open ? '検索を閉じる' : '検索を開く';

    if (!moveFocus) return;
    if (open) {
      requestAnimationFrame(() => searchInput.focus());
    } else {
      searchToggle?.focus();
    }
  }

  searchToggle?.addEventListener('click', () => {
    setMobileSearchOpen(!searchForm.classList.contains('is-open'));
  });

  searchForm.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !searchForm.classList.contains('is-open')) return;
    event.preventDefault();
    setMobileSearchOpen(false);
  });

  searchButtons.forEach((button) => {
    button.addEventListener('click', () => {
      selectSearchMode(button.dataset.searchMode);
      searchInput.focus();
    });
  });

  searchForm.addEventListener('submit', (event) => {
    const config = searchModes[activeMode];
    const term = searchInput.value.trim();
    const query = config.prefix ? `${config.prefix} ${term}` : term;
    queryInput.value = query;
    typeInput.value = config.type;

    event.preventDefault();
    const searchUrl = new URL(searchForm.action, window.location.origin);
    searchUrl.searchParams.set('q', query);
    searchUrl.searchParams.set('type', config.type);
    window.location.assign(searchUrl);
  });
}
